"use strict";

/**
 * @description Initializes the password show/hide functionality
 */

function passwordShow() {
    const eyeButtons = Array.from(document.querySelectorAll(".button__eye"));
    eyeButtons.forEach(eyeButton => {
        eyeButton.addEventListener("click", function () {
            const $this = $(this);
            $this[0].classList.toggle("show");
            const $input = $this.siblings(".js-input-password");

            if ($input.length) {
                const isPasswordType = $input.attr("type") === "password";
                const showPasswordTitle = $this.data("title-show");
                const hidePasswordTitle = $this.data("title-hide");
                $input.attr("type", isPasswordType ? "text" : "password");
                $this.attr("title", isPasswordType ? hidePasswordTitle : showPasswordTitle);

                $input.focus();
            }
        });
    });
}

module.exports = passwordShow;
